import { render, staticRenderFns } from "./uide-B2.vue?vue&type=template&id=09632920"
import script from "./uide-B2.vue?vue&type=script&lang=js"
export * from "./uide-B2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports